import React, { useMemo } from 'react';

import { Journey } from 'src/common/interfaces/journey.interface';

import { useSharePanelStore } from 'src/common/store/share.store';
import { ShareConfigEmbedCode } from './configure/embed';
import { ShareConfigAccessPanel } from './configure/access';
import { ShareConfigAccessSignaturesPanel } from './configure/access-signatures';
import { ShareConfigConversationPanel } from './configure/conversation';
import { ShareLinkFormPanel } from './configure/additional-link';
import { ShareConfigPersonalizationPanel } from './configure/personalization/personalization.panel';
import { ShareCustomFields } from '../form/fields/custom-fields';
import { ShareConfigCustomFieldsPanel } from './configure/custom-fields';
import { ShareConfigIndexingPanel } from './configure/indexing';
import { ShareConfigPresentationPanel } from './configure/presentation';
import { ShareConfigEmailParamsPanel } from './configure/email-params';
import { ShareConfigUTMParamsPanel } from './configure/utm-params';

interface Props {
  journey: Journey;
}

const ShareConfigurePanel = ({ journey }: Props) => {
  const linkConfigTree = useSharePanelStore((state) => state.linkConfigTree);

  const activeConfigPanel = useMemo(() => linkConfigTree[linkConfigTree.length - 1], [linkConfigTree]);

  const panel = useMemo(() => {
    switch (activeConfigPanel) {
      case 'embed':
        return <ShareConfigEmbedCode />;
      case 'access':
        return <ShareConfigAccessPanel />;
      case 'signatures':
        return <ShareConfigAccessSignaturesPanel />;
      case 'additional-link':
        return <ShareLinkFormPanel />;
      case 'personalization':
        return <ShareConfigPersonalizationPanel />;
      case 'conversations':
        return <ShareConfigConversationPanel />;
      case 'custom-fields':
        return <ShareConfigCustomFieldsPanel />;
      case 'indexing':
        return <ShareConfigIndexingPanel />;
      case 'presentation':
        return <ShareConfigPresentationPanel />;
      case 'email-params':
        return <ShareConfigEmailParamsPanel />;
      case 'utm-params':
        return <ShareConfigUTMParamsPanel />;
      default:
        return null;
    }
  }, [activeConfigPanel]);

  return !journey ? null : panel;
};

export default ShareConfigurePanel;
